export const META_PIXEL_ID = '29044871791789554'

const CONTENT_PARAMS = {
  content_name: 'Gospel Sharing Mega Bundle',
  content_type: 'product',
}

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
    __packPixelInstalled?: boolean
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const NOSCRIPT_ID = 'meta-pixel-noscript'
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/**
 * Meta Pixel base code, installed once in the global <head> before the app renders.
 * Loads fbevents.js, runs init and fires a single PageView. Guarded against duplicates.
 */
export function installMetaPixelBase(): void {
  if (typeof window === 'undefined') return
  if (window.__packPixelInstalled) return
  window.__packPixelInstalled = true

  if (document.getElementById(SCRIPT_ID)) return

  // <!-- Meta Pixel Code --> (official snippet, inserted verbatim into <head>)
  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.text = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'${SCRIPT_SRC}');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');
`
  document.head.appendChild(script)

  if (!document.getElementById(NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript')
    noscript.id = NOSCRIPT_ID
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`
    document.head.appendChild(noscript)
  }
  // <!-- End Meta Pixel Code -->
}

let viewContentTracked = false

/** Fires ViewContent once per page load (PageView is handled by the base code). */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  installMetaPixelBase()
  if (viewContentTracked) return
  viewContentTracked = true
  window.fbq?.('track', 'ViewContent', CONTENT_PARAMS)
}

/** Fires InitiateCheckout without navigating (for new-tab clicks). */
export function trackInitiateCheckoutOnly(): void {
  window.fbq?.('track', 'InitiateCheckout', CONTENT_PARAMS)
}

let checkoutInFlight = false

/** Fires InitiateCheckout, then continues to checkout. A lock prevents double-click duplicates. */
export function trackInitiateCheckout(href: string): void {
  if (typeof window === 'undefined') return
  if (checkoutInFlight) return
  checkoutInFlight = true

  window.fbq?.('track', 'InitiateCheckout', CONTENT_PARAMS)

  window.setTimeout(() => {
    window.location.href = href
    window.setTimeout(() => {
      checkoutInFlight = false
    }, 1500)
  }, 250)
}
